import { render, staticRenderFns } from "./SalespersonList.vue?vue&type=template&id=1b324f77&scoped=true"
import script from "./SalespersonList.vue?vue&type=script&lang=js"
export * from "./SalespersonList.vue?vue&type=script&lang=js"
import style0 from "./SalespersonList.vue?vue&type=style&index=0&id=1b324f77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b324f77",
  null
  
)

export default component.exports